<template>
  <form dusk="registration-step-3" class="step" data-vv-scope="form3" id="form3" :style="{'justify-content':buttonToTop ? 'flex-start' : 'center','flex-flow' : buttonToTop ? 'column' : 'wrap'}">
      <div class="form-inner">
        <div class="headline">{{ nickNameStep === 1 ? trans('reg.pick_nickname') : trans("reg.pick_handle") }}</div>
        <label v-show="nickNameStep === 1" class="registration-nickname">
          <input
              dusk="registration-nickname"
              class="form-control dark"
              type="text"
              id="nickname"
              @keydown="firstopen = false"
              v-bind:placeholder="trans('reg.nickname')"
              v-bind:data-vv-as="trans('reg.nickname')"
              v-model="nickname"
              v-validate="{required: true, min: 3, max: 50}"
              :class="{'is-invalid-input': errors.has('form3.nickname')}" name="nickname"
              required>

          <span class="form-error"  :class="{'is-visible': errors.has('form3.nickname')}">
                {{ errors.first('form3.nickname') }}
              </span>
        </label>

        <label v-show="nickNameStep === 2" class="registration-handle">
          <input class="form-control dark"
                 type="text"
                 v-bind:placeholder="trans('display_link')"
                 v-bind:data-vv-as="trans('link')"
                 @keyup="checkLink"
                 required
                 v-model="handle"
                 v-validate="{handle: true}"
                 :class="{'is-invalid-input': errors.has('form3.handle')}"
                 id="handle"
                 name="handle">

          <span class="form-error" :class="{'is-visible': errors.has('form3.handle')}">
              {{ errors.first('form3.handle') }}
          </span>
        </label>
        <p class="text-mute handle-success" v-if="nickNameStep === 2 && !handle_description && !errors.has('form3.handle')">{{trans('reg.handle_available')}}</p>
        <p  v-if="nickNameStep === 2 && handle_description" class="text-mute">{{ trans("reg.handle_description")}}</p>
      </div>
      <div class="form-footer">
        <div v-if="handle_suggestions.length && nickNameStep === 2" class="handdle-suggestions">
          <p>{{trans('reg.suggestions')}}</p>
          <div class="items">
            <div @click="chooseHandle(suggest)" class="item" v-for="suggest in handle_suggestions">{{suggest}}</div>
          </div>
        </div>
          <div class="btns">
            <button  type="button" :disabled="(nickNameStep === 1 && (!nickname || errors.has('form3.nickname'))) || (nickNameStep === 2 && errors.has('form3.handle'))" @click="submitForm()" dusk="registration-next"  class="btn btn-primary btn-long btn-rounded" id="button3">{{ trans('reg.next') }}</button>
          </div>
      </div>
  </form>
</template>

<script>
import VeeValidate, { Validator } from 'vee-validate';
Validator.extend('handle', {
  validate: function(value){
    return value && value.length >= 4 &&  value.length <= 15 && value.match(/^[a-zA-Z0-9\-_.]+$/) !== null
  }
});
export default {
  mixins: [require('@general/lib/mixin').default],
  props: ['vars'],
  data() {
    return this.vars;
  },
  computed: {
    env() {
      return window.APP_ENV
    }
  },
  components: {
  },
  methods: {
    chooseHandle(new_handle){
      this.handle = new_handle;
      this.handle_suggestions = [];
    },
    async checkLink(){
      this.handle_suggestions = [];
      this.handle_description = false
      if(!this.errors.has('form3.handle')){
        let checklink = await this.$store.dispatch('checkUserLink',{handle: this.handle, type:'user', id: 0});
        if(!checklink.data.success){
          this.errors.add({
            field: 'form3.handle',
            msg: this.trans('reg.handle_already_taken')
          });
          this.handle_suggestions = checklink.data.links_suggestions;
        }
      }
    },
    async suggestLink(){
        let link_suggestion =  this.nickname.replaceAll(/[^a-zA-Z0-9-._]+/g, "").substring(0, 15)
        let checklink = await this.$store.dispatch('checkUserLink',{handle: link_suggestion, type:'user', id: 0})
        if(checklink.data.success){
          this.handle = link_suggestion;
        }else{
          this.handle = checklink.data.links_suggestions[0];
        }
    },
    async submitForm(){
      if(this.nickNameStep === 1){
        let response = await axios.post('/api/register/validate-headline', {headline: this.nickname})
        if (response.data.success) {
          if(!this.handle){
            await this.suggestLink();
          }
          this.nickNameStep = 2;
          if(this.buttonToTop || this.isDesktop){
            var handle = document.getElementById('handle');

            this.$nextTick(() => {
              handle.focus();
            });
          }
        }else{
          this.errors.add({
            field: 'form3.nickname',
            msg: response.data.errors.headline[0]
          });
        }
      }else{
        await this.checkLink();
        if(!this.errors.has('form3.handle')){
          this.step = 4;
        }
      }
    },
  },
  mounted() {
    let nickname = document.getElementById('nickname');
    this.honeypot.hide = true
    let self = this;
    if(this.isMobile){
      nickname.addEventListener("focus", () => {
        self.buttonToTop = true;
      })
      nickname.addEventListener("blur", () => {
        self.buttonToTop = false;
      })
      nickname.focus();
      let handle = document.getElementById('handle');
      handle.addEventListener("focus", () => {
        self.buttonToTop = true;
      })
      handle.addEventListener("blur", () => {
        self.buttonToTop = false;
      })

      document.getElementById('button3').addEventListener('touchend', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(!((this.nickNameStep === 1 && (!this.nickname || this.errors.has('form3.nickname'))) || (this.nickNameStep === 2 && this.errors.has('form3.handle')))){
          this.submitForm()
        }
      });
    }


  },
}
</script>